import { routes } from '../../config/roleConfig';


export const hasRouteAccess = (path, roleName) => {
  // Check for direct route match
  if (routes[path] && routes[path].includes(roleName)) {
    return true;
  }

  // Check for dynamic routes with path parameters
  const pathSegments = path.split('/').filter(Boolean);

  for (const route in routes) {
    const routeSegments = route.split('/').filter(Boolean);
    
    if (pathSegments.length !== routeSegments.length) {
      continue;
    }
    
    let isMatch = true;
    for (let i = 0; i < routeSegments.length; i++) {
      // Skip parameter segments (those starting with :)
      if (routeSegments[i].startsWith(':')) {
        continue;
      }
      
      if (routeSegments[i] !== pathSegments[i]) {
        isMatch = false;
        break;
      }
    }
    
    if (isMatch && routes[route].includes(roleName)) {
      return true;
    }
  }
  
  return false;
};